import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';

// ** rxjs
import { Observable, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// ** env
import { config } from '@app/core/app.config';

// ** service
import { ErrorCatchService } from './errorCatch.service';
@Injectable({
	providedIn: 'root',
})
export class SuccessService {
	constructor(
		private http: HttpClient,
		private router: Router,
		private httpClient: HttpClient,
		private errorCatchService: ErrorCatchService
	) {}

	// - 取得成功案列 (總覽)
	getSuccessSheet(): Observable<any> {
		const fileName = 'success-sheet.json';
		return this.httpClient.get(`${config.success}/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}

	// - 取得成功案列全文
	getFullPiece(file: string) {
		const fileName = file;
		return this.httpClient.get(`${config.success}/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}
}
